import React, { useState } from 'react';
import { BtnAlternative } from '../../share/buttons/Btn';
import { BtnPrimary } from '../../share/buttons/Btn';
import Inputs from '../../share/input/Inputs';
import { set, useForm } from 'react-hook-form';
import IconButton from "../../share/buttons/IconButton";
import { AiOutlinePlus, AiOutlineMinus } from "react-icons/ai";
import BootcampDescription from './BootcampDescription';



function BootcampsTickets() {

    const [ticketInfos, setTicketInfo] = useState([
        {
            ticketname: 'بلیط کسب و کار',
            price: '20,000تومان',
            intPrice: 20000

        },
        {
            ticketname: 'بلیط طراح ',
            price: '20,000تومان',
            intPrice: 20000


        },
        {
            ticketname: 'بلیط برنامه نویس ',
            price: '20,000تومان',
            intPrice: 20000

        }
    ]);


    const [num, setNum] = useState([0, 0, 0]);
    const [totalPrice, setTotalPrice] = useState(0);

    const {
        handleSubmit,
        control,
        register,
        reset,
        formState: { errors, isSubmitted },
    } = useForm();
    const onSubmit = (data) => {
        console.log("first");
    };



    // increase price
    const handleIncreasePrice = (i) => {
        let before = [...num];
        before[i] += 1;
        setNum(before);
        setTotalPrice(prev => prev + (ticketInfos[i].intPrice));
       
    }

    // decrease price
    const handleDecreasePrice = (i) => {
        let before = [...num];
        if (before[i] > 0) {
            before[i] -= 1;
            setNum(before);
            setTotalPrice(totalPrice - ticketInfos[i].intPrice);


        } else {
            before[i] = 0;
            setNum(before);
            if (before[i] > 0) {
                setTotalPrice(totalPrice - ticketInfos[i].intPrice);

            }

        }

    }

    var intArr = totalPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var intArr = intArr.slice(0, 8);
    var replace_item = "...," + intArr;


    return (
        <div >
            <h2 className='text-[2rem] text-light-prim1 font-bold mb-[3.2rem] '>بلیت های بوت کمپ</h2>

            <div className='shadow-btn pt-[3.4rem] pr-[4.9rem] pl-[2.5rem] pb-[3.2rem] rounded-[1.5rem] mb-[7.3rem]'>
                <div className='grid grid-cols-4 pb-[1.5rem]  mb-[2.2rem] botcampticket__title'>
                    <span className='text-[1.4rem] text-light-prim col-span-2'>نام بلیط</span>
                    <span className='text-[1.4rem] text-light-prim '> قیمت</span>
                    <span className='text-[1.4rem] text-light-prim'> تعداد</span>

                </div>

                {ticketInfos.map((ticketinf, i) => {
                    return [
                        <div >
                            <div className='grid grid-cols-4 mb-[3rem]'>
                                <span className='text-[1.8rem] text-light-prim1 col-span-2'>  {ticketinf.ticketname}  </span>
                                <span className='text-[1.8rem] text-light-prim1'> {ticketinf.price}</span>
                                <div className='text-[1.8rem] text-light-prim1'>
                                    <form onSubmit={handleSubmit(onSubmit)} className="flex">
                                        <IconButton
                                            className=""
                                            text="اضافه کردن تعداد"
                                            type="button"
                                            onClick={
                                                () => handleIncreasePrice(i)

                                            }
                                        >
                                            <AiOutlinePlus className=" text=[1.6rem] text-light-prim1 " />
                                        </IconButton>
                                        <div className='input__styles'>
                                            <Inputs
                                                register={{
                                                    required: {
                                                        value: true,
                                                        message: "choose a number",
                                                    },
                                                }}

                                                type="number"
                                                name="company_name"
                                                control={control}
                                                className="bg-white-dark text-light-prim1 text-[1.8rem] w-[5.9rem] text-center "
                                                placeholder="0"
                                                value={num[i]}
                                            />
                                        </div>

                                        <IconButton
                                            className="button__minus cursor-pointer"
                                            disabled={num < 1}
                                            text="کم کردن تعداد"
                                            type="button"
                                            onClick={() => handleDecreasePrice(i)}
                                        >
                                            <AiOutlineMinus className=" text=[1.6rem] text-light-prim1 " />
                                        </IconButton>
                                    </form>


                                </div>
                            </div>
                        </div>
                    ]

                })}


                <div className='flex justify-between pt-[1rem] botcampticket__btns'>
                    <div className='flex items-center'>
                        <Inputs
                            register={{
                                required: {
                                    value: true,
                                    message: "choose a number",
                                },
                            }}
                            type="text"
                            name="sale"
                            control={control}
                            placeholder="کد تخفیف"
                            className="py-[2.9rem] px-[2.5rem] text-[1.8rem] rounded-[1.5rem] border-[.1rem] border-gray-light2 ml-[.8rem] bg-white-dark"
                        />
                        <BtnAlternative className="p-[2.4rem]" text=" اعمال کد تخفیف" />
                    </div>

                    <BtnPrimary text={`ثبت نام ${num == 0 ? "(" + 0 + ")" : "(" + replace_item + " تومان )"} `} className="px-[2.6rem] py-[1.9rem]">

                    </BtnPrimary>

                </div>
            </div>
            <BootcampDescription />
        </div >
    )
}

export default BootcampsTickets